import React, { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { useMutation } from "@apollo/client";
import { PROCESS_STRIPE_CHECKOUT } from "@/integrations/apollo/operations";
import { useLocation } from 'react-router-dom';

function useQueryParams() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ProcessCheckout = () => {
  const queryParams = useQueryParams();
  const sessionId = queryParams.get('session_id');
  const [processStripeCheckout] = useMutation(PROCESS_STRIPE_CHECKOUT);

  useEffect(() => {
    const processCheckout = async () => {
      if (sessionId) {
        try {
          const { data, errors } = await processStripeCheckout({
            variables: {
              checkout_session_id: sessionId,
            },
          });

          if (errors && errors.length > 0) {
            console.error('Error processing checkout:', errors);

            return;
          }

          if (data && data.processStripeCheckout) {
            const { redirect_url } = data.processStripeCheckout;

            window.location.href = redirect_url;
          }
        } catch (error) {
          console.error('Error processing checkout:', error);
        }
      }
    };

    processCheckout();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="mx-auto bg-background rounded-xl shadow-lg overflow-hidden px-8 py-8 relative">
        <Loader2 className="animate-spin" />
      </div>
    </div>
  );
};

export default ProcessCheckout;
